import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  imports: [FormsModule, TranslateModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {

  email: string = '';
  password: string = '';
  loading: boolean = false;
  showPassword: boolean = false;


  constructor(private authService: AuthService, private router: Router) { }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }


  async login() {
    this.loading = true;
    try {
      await this.authService.login(this.email, this.password);
      this.router.navigateByUrl('/admin');

    }
    catch (error) {
      console.error('Error en login:', error);
    } finally {
      this.loading = false;
    }
  }
}
